const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
const STORAGE_KEY = "bk_utms";

export const captureUTMs = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "{}");
    let changed = false;
    UTM_KEYS.forEach((key) => {
      const value = params.get(key);
      if (value) {
        stored[key] = value;
        changed = true;
      }
    });
    if (changed) sessionStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
  } catch (e) {
    /* storage unavailable */
  }
};

export const getUTMs = () => {
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "{}");
  } catch (e) {
    return {};
  }
};
